import Moment from "moment/moment";


export const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
};

export function calcAge(birthday) {
    return Math.floor(Moment(birthday).diff(Moment())/365.25)
}

export function getAbsoluteMonths(date) {
    const momentDate = Moment(date);
    const months = Number(momentDate.format("MM"));
    const years = Number(momentDate.format("YYYY"));
    return months + (years * 12);
}

export function addBusinessDays(originalDate, numDaysToAdd) {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = numDaysToAdd;

    const newDate = originalDate.clone();

    while (daysRemaining > 0) {
        newDate.add(1, 'days');
        if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
            daysRemaining--;
        }
    }

    return Moment(newDate);
}
